module.exports = __webpack_public_path__ + "static/assets/a335a316d183b79f06668897f6fbf047.svg";